import { render } from "./CpuChart.vue?vue&type=template&id=4a6ffa28&scoped=true"
import script from "./CpuChart.vue?vue&type=script&lang=js"
export * from "./CpuChart.vue?vue&type=script&lang=js"

import "./CpuChart.vue?vue&type=style&index=0&id=4a6ffa28&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6ffa28"]])

export default __exports__